import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, AlertTriangle } from "lucide-react";
import { BrandLogo } from "@/components/Navbar";
import { oidcCallback } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { ssoComplete } = useAuth();
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      const params = new URLSearchParams(window.location.search);
      const code = params.get("code");
      const returnedState = params.get("state");
      const expectedState = sessionStorage.getItem("oidc.state");
      const codeVerifier = sessionStorage.getItem("oidc.code_verifier");
      const nonce = sessionStorage.getItem("oidc.nonce");
      const redirectUri = sessionStorage.getItem("oidc.redirect_uri");

      if (!code || !returnedState || returnedState !== expectedState || !codeVerifier || !nonce || !redirectUri) {
        setError("Invalid or expired sign-in response. Please try again.");
        return;
      }
      try {
        const data = await oidcCallback({ code, code_verifier: codeVerifier, redirect_uri: redirectUri, nonce });
        ["oidc.state", "oidc.nonce", "oidc.code_verifier", "oidc.redirect_uri"].forEach((k) => sessionStorage.removeItem(k));
        ssoComplete(data.token, data.user);
        navigate(data.next || "/portal");
      } catch (e) {
        setError("Unable to complete sign-in with SocialPulse.");
      }
    })();
    // eslint-disable-next-line
  }, []);

  return (
    <main className="min-h-screen hero-bg flex flex-col items-center justify-center px-4">
      <BrandLogo size={44} />
      <div className="mt-8 text-center" data-testid="auth-callback">
        {error ? (
          <>
            <AlertTriangle className="mx-auto text-red-500" size={28} />
            <p className="text-slate-700 font-medium mt-3">{error}</p>
            <button onClick={() => navigate("/login")} className="btn-primary rounded-lg px-6 py-2.5 mt-5">Back to login</button>
          </>
        ) : (
          <>
            <Loader2 className="mx-auto animate-spin text-brand" size={28} />
            <p className="text-slate-600 mt-3">Signing you in with SocialPulse…</p>
          </>
        )}
      </div>
    </main>
  );
}
